import { useColorModeValue } from '@chakra-ui/color-mode';
import { Box, Center, Text, VStack } from '@chakra-ui/layout';
import useDocumentTitle from '../hooks/useDocumentTitle';
import AOS from 'aos';
import 'aos/dist/aos.css';

const About = () => {
	useDocumentTitle();
	AOS.init();

	return (
		<Box
			minHeight={{ md: 'calc(100vh - 120px)' }}
			background={useColorModeValue('gray.50', 'gray.800')}
			p={5}
		>
			<Center data-aos="fade-down" data-aos-anchor-easing='ease-in-out' data-aos-anchor-placement="top-center" minHeight={{ md: 'calc(100vh - 250px)' }} px={9}>
				<VStack>
					<Text display='inline' fontSize={{ base: '3xl', md: '7xl' }} fontWeight='600'>
						Trey Burleson
					</Text>
					<Text fontSize={{ base: 'xl', md: '4xl' }}>
						a <Text display='inline' borderBottomColor='red.500' borderBottomWidth='2px' borderBottomRadius='4px' fontSize={{ base: '2xl', md: '4xl' }} fontWeight='400'>Web Designer</Text>
						{' '}at heart
					</Text>
					<Text fontSize={{ base: 'xl', md: '4xl' }} as='span'>
						Currently re-learning{' '}
						<Text
							display='inline'
							borderBottomColor='red.500'
							borderBottomWidth='2px'
							borderBottomRadius='2px'
						>
							Typescript
						</Text>{' '}
						to be a better programmer.
					</Text>
				</VStack>
			</Center>
		</Box>
	);
};

export default About;
